<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="项目/甲方/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="项目类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="项目状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建零星项目</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="small_project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" fixed-shadow="hide" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.small_project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #total_money="{ row }">
                                    <div class="d-width" :title="row.total_money">
                                        <strong class="text-violet">{{row.total_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #collection_money="{ row }">
                                    <div class="d-width" :title="row.collection_money">
                                        <strong class="text-success">{{row.collection_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #debt_money="{ row }">
                                    <div class="d-width" :title="row.debt_money">
                                        <strong class="text-danger">{{row.debt_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expend_money="{ row }">
                                    <div class="d-width" :title="row.expend_money">
                                        <strong class="text-orange">{{row.expend_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expense_money="{ row }">
                                    <div class="d-width" :title="row.expense_money">
                                        <strong class="text-orange">{{row.expense_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #invoice_money="{ row }">
                                    <div class="d-width" :title="row.invoice_money">
                                        <strong class="text-primary">{{row.invoice_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #customer_name="{ row }">
                                    <div class="d-width" :title="row.customer_name">
                                        {{row.customer_name ?? '-'}}
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 2" color="red" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-primary" @click="editData(row.small_project_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-violet" @click="logData(row.small_project_id, row.name)">日志</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-danger" @click="deleteData(row.small_project_id)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 零星项目详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 零星项目日志  -->
                    <log-modal v-if="is_log" ref="LogRef"></log-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getDispersedConfig, getDispersedList, deleteDispersed} from '@/apis/dispersed'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./Create";
import ShowModal from "./Show";
import LogModal from "./Log";
import expandRow from "./Expand";
export default {
    name: "DispersedIndex",
    components: {
        Headers, Side, AddModal, ShowModal, LogModal
    },
    data () {
        return {
            typeList: [],
            userList: [],
            statusList: [],

            search: {
                name: '',
                type_id: '',
                head_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, data) => {
                        return h(expandRow, {
                            ref: `disperseView_${data.index}`,
                            rowData: data.row, // 传参
                            onReloadData:(small_project_id) => {
                                let that = this;
                                //确保dom更新完成
                                this.$nextTick(() => {
                                    that.getListRefresh(small_project_id);
                                })
                            }
                        })
                    }
                },
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    minWidth: 160,
                },
                {
                    title: '项目类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120
                },
                {
                    title: '项目总金额',
                    key: 'total_money',
                    slot: 'total_money',
                    width: 120
                },
                {
                    title: '回款金额',
                    key: 'collection_money',
                    slot: 'collection_money',
                    width: 120
                },
                {
                    title: '欠款金额',
                    key: 'debt_money',
                    slot: 'debt_money',
                    width: 120
                },
                {
                    title: '支出金额',
                    key: 'expend_money',
                    slot: 'expend_money',
                    width: 120
                },
                {
                    title: '报销金额',
                    key: 'expense_money',
                    slot: 'expense_money',
                    width: 120
                },
                {
                    title: '开票金额',
                    key: 'invoice_money',
                    slot: 'invoice_money',
                    width: 120
                },
                {
                    title: '甲方',
                    key: 'customer_name',
                    slot: 'customer_name',
                    width: 180
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 100
                },
                {
                    title: '项目状态',
                    key: 'status',
                    slot: 'status',
                    width: 110
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    width : 150
                }
            ],
            is_create : false,
            is_show : false,
            is_log : false,
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：搜索
         time: 2026/09/12
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：刷新
         time: 2026/09/12
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                head_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        getConfig(){
            let that = this;
            getDispersedConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         功能：列表
         time: 2026/09/12
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getDispersedList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：Expand修改触发刷新
         time: 2026/09/12
         **/
        getListRefresh(small_project_id){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getDispersedList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
                that.dataList.data.forEach((item, index) => {
                    if(parseInt(item.small_project_id) === parseInt(small_project_id)){
                        that.dataList.data[index]._expanded = true; //展开选中的行
                    }
                })
            })
        },
        /**
         功能：分页
         time: 2026/09/12
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：创建
         time: 2026/09/12
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        editData(small_project_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(small_project_id);
            })
        },
        /**
         功能：操作返回
         time: 2026/09/12
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：日志
         time: 2026/09/12
         **/
        logData(small_project_id, name ){
            let that = this;
            that.is_log = true;
            setTimeout(function(){
                that.$refs.LogRef.show(small_project_id, name);
            })
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        showData(small_project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(small_project_id);
            })
        },
        /**
         功能：删除
         time: 2026/09/12
         **/
        deleteData(small_project_id){
            let that = this;
            if(!small_project_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除零星项目',
                content: '此操作将删除零星项目不可恢复, 是否继续?',
                onOk: () => {
                    deleteDispersed(small_project_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
